export const CHECKLIST_AUTO_RELOAD_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes
